import { Box, createStyles, makeStyles } from '@material-ui/core'
import { LinkedIn, Twitter, YouTube } from '@material-ui/icons'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    link: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      padding: '6px',
      width: '45px',
      height: '45px',

      '&:hover': {
        background: '#ccc3',
      },
    },
  })
)

export const SocialMedia = () => {
  const styles = useStyles()

  return (
    <Box className={styles.root}>
      <a
        className={styles.link}
        href="https://twitter.com/QuotationFact"
        target="_blank"
        rel="noreferrer"
      >
        <Twitter fontSize="large" />
      </a>
      <a
        className={styles.link}
        href="https://www.linkedin.com/company/77644228"
        target="_blank"
        rel="noreferrer"
      >
        <LinkedIn fontSize="large" />
      </a>
      <a
        className={styles.link}
        href="https://www.youtube.com/@quotationfactory5654"
        target="_blank"
        rel="noreferrer"
      >
        <YouTube fontSize="large" />
      </a>
    </Box>
  )
}
